module.exports = __webpack_public_path__ + "img/sport-none.3a6256c0.jpg";